import PropTypes from 'prop-types';
import {
  StyledWrapper,
  StyledSection,
  StyledList,
  StyledListItem,
  StyledImageWrapper,
  StyledImage,
  StyledLink,
  StyledTitle,
} from './SubcategoriesList.styles';

function SubcategoriesList({ listData }) {
  if (!listData.length) return null;

  return (
    <StyledSection>
      <StyledWrapper>
        <StyledList>
          {listData.map(item => (
            <StyledListItem key={item.id}>
              <StyledLink to={item.link ? `${item.link}` : './'}>
                {item.image && (
                  <StyledImageWrapper>
                    <StyledImage src={item.image.url} alt={item.image.alt} />
                  </StyledImageWrapper>
                )}
                <StyledTitle>{item.title ? item.title : 'Insert subcategory title'}</StyledTitle>
              </StyledLink>
            </StyledListItem>
          ))}
        </StyledList>
      </StyledWrapper>
    </StyledSection>
  );
}

SubcategoriesList.propTypes = {
  listData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      link: PropTypes.string,
      image: PropTypes.shape({
        url: PropTypes.string.isRequired,
        alt: PropTypes.string.isRequired,
      }),
      title: PropTypes.string.isRequired,
    })
  ),
};

SubcategoriesList.defaultProps = {
  listData: {},
};

export default SubcategoriesList;
